<template>
    <div>
        <div v-if="$route.matched.length == 2" class="d-flex flex-row w-100" slot="center">
            <CompanyList
                chatFilterButton
                :data="featuredCompanies"
                label="Companies"
                class="mb-3 w-100"
                :resolveroute="companyClickRoute"
                :chat-availability="chatUserSummaryData()"
                :isLoading="loading"
            ></CompanyList>
        </div>
        <div class="grid-bottom" v-if="$route.matched.length == 2" slot="center">
            <div>
                <EventList
                    :value="events.slice(0, 5)"
                    class="mb-4"
                    :vFairId="this.$route.params.id"
                ></EventList>
            </div>
            <div>
                <PostingModule
                    :data="postingData"
                    class="mb-3 w-100"
                    :resolveroute="resolveRoute"
                    :isLoading="postingLoading()"
                    noToggles
                ></PostingModule>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
import CompanyList from '~/shared/CompanyList';
import EventList from './components/EventList';
import { SHOW_CHAT_IN_COMPANY_LIST } from '~/router';
import PostingModule from '../../../shared/postingmodule/PostingModule';
import MainLayout from '../../../components/layouts/mainlayout/MainLayout';

export default {
    name: 'Companies',
    components: {
        MainLayout,
        PostingModule,
        CompanyList,
        EventList,
    },
    data() {
        return {};
    },
    computed: {
        postings() {
            return this.$interfaces.posting.get({
                reactive: true,
                vfair_id: this.$route.params.id,
                page_size: 5,
                page: 1,
            });
        },
        postingData() {
            return this.postings.data || [];
        },
        companiesRequest() {
            if (this.$route.params.id) {
                return this.$interfaces.vfair.id(this.$route.params.id).organizations.get({
                    reactive: true,
                });
            } else {
                return { loading: true };
            }
        },
        companies() {
            if (this.companiesRequest.loading) {
                return [];
            } else {
                return this.companiesRequest.data.filter(item => {
                    if (item) {
                        return item.status === 2;
                    }
                    return false;
                });
            }
        },
        loading() {
            return this.companiesRequest.loading;
        },
        featuredCompanies() {
            return this.companies.map(org => {
                return {
                    id: org.organizationId,
                    logo: org.logo,
                    name: org.title,
                };
            });
        },
        events() {
            if (!this.$route.params.id) {
                return [];
            } else {
                return this.$interfaces.vfair.id(this.$route.params.id).events.get({
                    reactive: true,
                }).data;
            }
        },
        chatUserSummary() {
            return SHOW_CHAT_IN_COMPANY_LIST
                ? this.$interfaces.communication.chat.availability.summary.get({
                      reactive: true,
                  })
                : [];
        },
    },
    methods: {
        companyClickRoute(id) {
            const url = this.$URLS.vfair
                .concat('/', this.$route.params.id)
                .concat('/companies/', id);
            return url;
        },
        chatUserSummaryData() {
            return this.chatUserSummary.data;
        },
        chatUserSummaryLoading() {
            return this.chatUserSummary.loading;
        },
        postingLoading() {
            return this.postings.loading;
        },
        resolveRoute(jobAdId) {
            const url = this.$URLS.vfair
                .concat('/', this.$route.params.id)
                .concat('/jobs/', jobAdId);
            return url;
        },
    },
    mounted() {
        if (SHOW_CHAT_IN_COMPANY_LIST) {
            this.$interfaces.communication.chat.availability.summary.get({ forceUpdate: true });
        }
    },
};
</script>

<style scoped>
.grid-bottom {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: var(--grid-gap);
}
@media screen and (max-width: 1116px) {
    .grid-bottom {
        grid-template-columns: 1fr;
    }
}
</style>
